import React from "react";
import { ChevronRightIcon, ChevronsRightIcon, SearchIcon } from "lucide-react";
import { programSports, currentAgeGroups, ViewMode } from "../data/navigation";
import { MenuPanel, MenuHeading } from "./MenuPanel";
import { NoteTag } from "./NoteTag";
type ProgramsMenuProps = {
  view: ViewMode;
  showNotes: boolean;
};
export function ProgramsMenu({
  view,
  showNotes
}: ProgramsMenuProps) {
  const proposed = view === "proposed";
  const movedOutline = showNotes ? "outline-dashed outline-2 outline-offset-8 outline-i9-note/80" : "";
  return <MenuPanel data-id="element-151" data-mp="hbzhe9sw1lvv">
      <div className={`grid gap-10 px-9 pt-9 ${proposed ? "grid-cols-[1fr_190px_300px]" : "grid-cols-[1fr_340px]"}`} data-id="element-152" data-mp="hc951qqgngye">
        {/* Sports */}
        <div data-id="element-153" data-mp="q9jj1junxk70">
          <MenuHeading data-id="element-154" data-mp="q9t8957vvnbn">Find Programs</MenuHeading>
          {showNotes && <NoteTag className="mt-1" data-id="element-155" data-mp="26o1luaaoemb5">
              {proposed ? "Sole home for sports" : "Same sports as About › Sports We Play"}
            </NoteTag>}
          <div className="mt-4 grid grid-cols-2 gap-x-8" data-id="element-156" data-mp="s7ojerb5zlnu">
            {[programSports.slice(0, 6), programSports.slice(6)].map((col, i) => <ul key={i} className="space-y-3" data-id="element-157" data-mp="w88gxvzngrai" data-mpi={i}>
                {col.map(s => <li key={s} className="flex items-center gap-3" data-id="element-158" data-mp="11837fyfijev1">
                    <span className="h-6 w-6 shrink-0 rounded-full border-2 border-white/60" aria-hidden="true" data-id="element-159" data-mp="167fqe839k1sc" />
                    <a href="#" className="text-[16px] hover:underline" data-id="element-160" data-mp="8jyv4u2fs3jd">{s}</a>
                  </li>)}
                {i === 1 && <li data-id="element-161" data-mp="dj1sdsc6d5gs">
                    <a href="#" className="flex items-center gap-1 text-[15px] font-semibold uppercase hover:underline" data-id="element-162" data-mp="dgfkfrldgny1">
                      View All Sports <ChevronsRightIcon className="h-4 w-4" data-id="element-163" data-mp="n8v20nsrbaie" />
                    </a>
                  </li>}
              </ul>)}
          </div>
        </div>

        {/* Age groups — proposed only */}
        {proposed && <div className={`self-start ${movedOutline}`} data-id="element-164" data-mp="3qvlqx01vfmlw">
            <MenuHeading data-id="element-165" data-mp="3ivxkj2pydvbf">By Age Group</MenuHeading>
            {showNotes && <NoteTag className="mt-1" data-id="element-166" data-mp="3evnb1g2ycmrt">Moved from About Us</NoteTag>}
            <ul className="mt-4 space-y-3" data-id="element-167" data-mp="3etayjifyr4m5">
              {currentAgeGroups.map(g => <li key={g.code} className="flex items-center gap-3" data-id="element-168" data-mp="3sm0htf43xvfk">
                  <span className="flex h-7 w-7 items-center justify-center border border-white text-[11px] font-bold" style={{
              backgroundColor: g.color
            }} aria-hidden="true" data-id="element-169" data-mp="3noqp9qlf93ni">
                    {g.code}
                  </span>
                  <a href="#" className="text-[16px] hover:underline" data-id="element-170" data-mp="39x3s7ojnnr3o">{g.label}</a>
                </li>)}
            </ul>
          </div>}

        {/* Search + directory */}
        <div data-id="element-171" data-mp="p4s3344ofbp2">
          <MenuHeading data-id="element-172" data-mp="p48ljoixupbk">Find a Program Near You</MenuHeading>
          <div className="mt-4 flex" data-id="element-173" data-mp="k7rxsvfnicz0">
            <input aria-label="ZIP code" defaultValue="33578" className="h-11 w-full min-w-0 bg-white px-3 text-i9-ink" data-id="element-174" data-mp="k6qlyoqt9mg8" />
            <button className="flex h-11 shrink-0 items-center gap-1.5 bg-i9-red px-3 text-sm font-semibold" data-id="element-175" data-mp="226ya8zn4ns3v">
              <SearchIcon className="h-4 w-4" data-id="element-176" data-mp="1t3x7n8xh0j4y" /> Find Programs
            </button>
          </div>
          <div className="mt-8" data-id="element-177" data-mp="1y30dgvl9ytdz">
            <MenuHeading data-id="element-178" data-mp="1y28inmzi4zor">Program Directory</MenuHeading>
            <a href="#" className="mt-4 inline-flex h-10 items-center gap-1 bg-i9-red px-3 text-sm font-semibold" data-id="element-179" data-mp="1y4uw2392q9ew">
              Browse All Programs <ChevronRightIcon className="h-4 w-4" data-id="element-180" data-mp="2pufvecbvzrxv" />
            </a>
          </div>
        </div>
      </div>
    </MenuPanel>;
}